<ng-container *ngTemplateOutlet="pickerTemplate; context: {ctx: ctx}"></ng-container>
